export enum BillingConstants {
  NOT_IMPLEMENTED = 'Billing/NOT_IMPLEMENTED',
  SET_SELECTED_OPTION = 'Billing/SET_SELECTED_OPTION',
  INSURANCE_INFORMATION_OPTION = 'Billing/InsuranceInformation',
  RELATIONSHIPS_AND_GUARANTORS_OPTION = 'Billing/RelationshipsAndGuarantors',
  PCS_INFORMATION_OPTION = 'Billing/PcsInformation',
  AUTHORIZATION_INFORMATION_OPTION = 'Billing/AuthorizationInformation',
  CMS_INFORMATION = 'Billing/CMSInformation',
  PAYMENT_INFORMATION_OPTION = 'Billing/PaymentInformation',
  REFRESH_BILLING_DATA = 'Billing/REFRESH_BILLING_DATA',
}
